import { Observable } from 'rxjs';
import { DatatablePtConstant } from 'src/app/shared/constants/datatables-pt.constant';
import Swal, { SweetAlertOptions } from 'sweetalert2';
import { BaseComponent } from './base.component';

export abstract class BaseListComponent<T> extends BaseComponent {

  dtOptions1: any = {};
  lista1: T[];
  _language = DatatablePtConstant.TRADUCAO_DATATABLE_PT;

  alertConfirmation(data: any = null, msg = 'Tem certeza que deseja excluir?') {
    return new Observable<boolean>((observer) => {
      Swal.fire({
        title: '',
        text: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        customClass: 'sw-system',
      } as SweetAlertOptions).then((result) => {
        if (result.isConfirmed) {
          observer.next(true);
        } else {
          observer.next(false);
        }
        observer.complete();
      });
    });
  }

  confirmation(msg = 'Operação realizada com sucesso!', title = 'Sucesso', icon: any = 'success', cancel: boolean = false) {
    return new Observable<boolean>((observer) => {
      Swal.fire({
        title: title,
        text: msg,
        icon: icon,
        showCancelButton: cancel,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        customClass: 'sw-system-confirm',
      } as SweetAlertOptions).then((result) => {
        if (result.isConfirmed) {
          observer.next(true);
        } else {
          observer.next(false);
        }
        observer.complete();
      });
    });
  }

  msgSuccess(msg = 'Deletado com sucesso') {
    Swal.fire({
      title: 'Sucesso!',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
      customClass: 'sw-system-confirm',
    } as SweetAlertOptions);
  }

  msgError(erro = null) {
    Swal.fire({
      title: 'Erro na Solicitação',
      text: erro,
      icon: 'error',
      customClass: 'sw-system',
    } as SweetAlertOptions);
  }

  handleError(error) {
    this.msgError(error?.error?.message);
    this.loaded();
  }

  dtRerender(dtOptions: any) {
    dtOptions.destroy = true;
    dtOptions.dtTrigger.next();
  }
}
